import React from "react";
import TradingViewWidget from "react-tradingview-widget";

const SolanaGraph = () => {
  return (
    <div className="solana-chart">
      <h4 className="my-dash">Solana Price Chart</h4>
      <TradingViewWidget
        symbol="COINBASE:SOLUSD"
        autosize={true}
        interval="D"
        theme="Light"
        locale="en"
        toolbar_bg="#f1f3f6"
        allow_symbol_change={true}
        save_image={false}
        style="1"
      />
    </div>
  );
};

export default SolanaGraph;
